import RestClient from './RestClient';
import { TktUser } from '../../models';
import i18n from '../../locales/i18n';
import { getApiErrorMessage } from './getApiErrorMessage';

class TktUsers extends RestClient {
    constructor() {
        super({
            "model": TktUser,
            "entryPoint": "user",
            "resource": "user",
            "resources": "users",
            "id_field": "_id"
        });
    }

    list() {
        return this.GET('/user/list')
            .then(response => response.json())
            .then(json => {
                if (json.users)
                    return {
                        ...json,
                        tktusers: json.users.map(c => new TktUser(c))
                    };
            throw new Error(json.flash.error);
        });
    }

    create(payload) {
        payload = new TktUser(payload);

        if ('prepareForUpdate' in payload)
            payload = payload.prepareForUpdate();

        return this.POST(`/${this.entryPoint}${this.CREATE_PATH}`, { [this.resource]: payload })
            .then(response => response.json())
            .then(json => {
                if (json.user) {
                    json.tktuser = new TktUser(json.user);
                    return json;
                }
                if (json.invalid) {
                    const messages = [];
                    for (const [key, error] of Object.entries(json.invalid)) {
                        messages.push(i18n.t(`tktUsers.invalid.${key}.${error}`));
                    }
                    throw new Error(messages.join(', '));
                }
                throw new Error(json.flash.error);
            });
    }

    revealApiKey(id) {
        return this.GET(`/user/apikey/${id}`)
            .then(response => response.json())
            .then(json => {
                if (json.apikey)
                    return json;
            throw new Error(json.flash.error);
        });
    }

    extendApiKey(id, years = 1) {
        this.assertNotReadonlyEdition();
        return this.POST(`/user/extend_apikey/id/${id}`, { years })
            .then(response => response.json())
            .then(json => {
                if (json.apikey)
                    return json;
                throw new Error(getApiErrorMessage(json));
            });
    }

    issueTrampolineApiKey(id) {
        this.assertNotReadonlyEdition();
        return this.POST(`/user/trampoline_apikey/id/${id}`, {})
            .then(response => response.json())
            .then(json => {
                if (json.apikey)
                    return json;
                throw new Error(getApiErrorMessage(json));
            });
    }
}
const TktUsersApi = new TktUsers();

export default TktUsersApi;
